import { objectEntries } from "app/helpers/objects";
import { exportColumnAdapters } from "app/pages/sales-intelligence/modules/enrichment/services/column-adapters/exportColumnAdapters";
import type {
    BaseColumnConfig,
    CsvExportColumnOptions,
    CsvExportColumnType,
    CsvExportLeadsColumnConfigDto,
} from "app/pages/sales-intelligence/modules/enrichment/types/columns";
import { columnsService } from "app/pages/sales-intelligence/modules/leads-search/services/columns/columnsService";
import type { ColumnTransformConfig } from "app/pages/sales-intelligence/modules/leads-search/types/columns";
import { getAccountsFields } from "app/pages/sales-intelligence/pages/manage-integration/configs/accountsFields";
import type { AccountsFieldKey } from "app/pages/sales-intelligence/common-components/export-table/types";

import type { FieldItem } from "../store/type";

export const fromDtoToColumnExportOptions = (dto: CsvExportLeadsColumnConfigDto): CsvExportColumnOptions => {
    const columnsExampleValues = getAccountsFields();

    const config: ColumnTransformConfig<FieldItem, CsvExportColumnType> = {
        adapter: (column) => {
            if (columnsService.isDynamicColumn(column)) {
                return exportColumnAdapters.createDynamicColumnFieldAdapter(
                    column,
                    columnsExampleValues[column.id as AccountsFieldKey]?.example,
                );
            }

            return exportColumnAdapters.createColumnFieldAdapter(
                column,
                columnsExampleValues[column.id as AccountsFieldKey]?.example,
            );
        },
    };

    const transformCategories = <T extends BaseColumnConfig<string, CsvExportColumnType>>(
        categories: T,
    ): BaseColumnConfig<keyof T, FieldItem> =>
        Object.fromEntries(
            objectEntries(categories).map(([category, columns]) => [
                category,
                columnsService.transformColumns(columns, config),
            ]),
        ) as BaseColumnConfig<keyof T, FieldItem>;

    return {
        leads: transformCategories(dto.leads),
        contacts: transformCategories(dto.contacts),
    };
};
